/**
 * 文件加载类
 * @class UtilLoad
 * @example
 * import WSLib from '@tencent/weishi-lib';
 * WSLib.wsUtil.load.loadJs('path/a.js', () => {});
 */
class UtilLoad {
  /**
   * 加载 js 文件
   * @param {String} url js文件地址
   * @param {Function} cb 回调函数
   */
  loadJs(url, cb) {
    const script = document.createElement('script');
    script.src = url;
    script.type = 'text/javascript';
    // script.crossOrigin = 'anonymous';  // 不需要做跨域检查
    // 只用兼容手机
    script.onload = function () {
      if (cb) {
        cb(null);
      }
    };
    script.onerror = function (e) {
      if (cb) {
        cb(e);
      }
    };
    document.body.appendChild(script);
  }

  /**
   * 加载 css 文件
   * @param {String} url css文件地址
   * @param {Function} cb 回调函数
   */
  loadCss(url, cb) {
    const link = document.createElement('link');
    link.href = url;
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.onload = function () {
      if (cb) {
        cb();
      }
    };
    link.onerror = function (e) {
      if (cb) {
        cb(e);
      }
    };
    document.head.appendChild(link);
  }
}

export default new UtilLoad();
